import { Divider, FormControl, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectOptions, setChartOrientation } from '../reducers/optionsSlice';


const useStyles = makeStyles(theme => ({
  chartOptionsHorizontal: {
    position: 'relative', 
    zIndex: 69, 
    overflow: 'hidden',
    display: 'flex',
    flexWrap: 'wrap'
  },
}));

export const WaterfloodChartOptions = ({ list, darkMode }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const options = useSelector(selectOptions);

  // const handleChartTypeChange = (event, newType) => {
  //   newType && dispatch(setChartType(newType));
  // };
  const handleChartOrientationChange = (event, newOrientation) => {
    newOrientation && dispatch(setChartOrientation(newOrientation));
  };

  return (
    <div className={classes.chartOptionsHorizontal}>

      {/* <FormControl style={{marginRight: 10, marginBottom: 5}}>
        <Typography variant="subtitle2" color="textSecondary" style={{fontWeight: 'bold', fontSize: 12}}>
          CHART TYPE
        </Typography>
        <ToggleButtonGroup
          value={options.chartType}
          exclusive
          onChange={handleChartTypeChange}
          size="small"
          style={{marginTop: 0, height: 30}}
        >
          <ToggleButton value={'Rate-Time'} size="small" color={(darkMode ? "" : "primary")}>
            <Typography style={{fontSize: 12}}>
              Rate-Time
            </Typography>
          </ToggleButton>
          <ToggleButton value={'Rate-Cum.'} size="small" color={(darkMode ? "" : "primary")}>
            <Typography style={{fontSize: 12}}>
              Rate-Cum.
            </Typography>
          </ToggleButton>
        </ToggleButtonGroup>
      </FormControl> */}

      <FormControl style={{marginRight: 10, marginBottom: 5}}>
        <Typography variant="subtitle2" color="textSecondary" style={{fontWeight: 'bold', fontSize: 12}}>
          CHART LAYOUT
        </Typography>
        <ToggleButtonGroup
          value={options.chartOrientation}
          exclusive
          onChange={handleChartOrientationChange}
          size="small"
          style={{marginTop: 0, height: 30}}
        >
          <ToggleButton value={'Horizontal'} size="small" color={(darkMode ? "" : "primary")}>
            <Typography style={{fontSize: 12}}>
              Horizontal
            </Typography>
          </ToggleButton>
          <ToggleButton value={'Vertical'} size="small" color={(darkMode ? "" : "primary")}>
            <Typography style={{fontSize: 12}}>
              Vertical
            </Typography>
          </ToggleButton>
        </ToggleButtonGroup>
      </FormControl>
      <Divider style={{marginTop: 10}} />
    </div>
  );

};
